import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "messages-list-dragover-wrapper" }
const _hoisted_2 = { class: "scroll-to-bottom" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_GuestWelcomeWindow = _resolveComponent("GuestWelcomeWindow")
  const _component_NcIconSvgWrapper = _resolveComponent("NcIconSvgWrapper")
  const _component_IconAccountOutline = _resolveComponent("IconAccountOutline")
  const _component_IconAlertOctagonOutline = _resolveComponent("IconAlertOctagonOutline")
  const _component_NcEmptyContent = _resolveComponent("NcEmptyContent")
  const _component_TransitionWrapper = _resolveComponent("TransitionWrapper")
  const _component_ThreadHeader = _resolveComponent("ThreadHeader")
  const _component_MessagesList = _resolveComponent("MessagesList")
  const _component_IconChevronDoubleDown = _resolveComponent("IconChevronDoubleDown")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NewMessage = _resolveComponent("NewMessage")
  const _component_NewMessageUploadEditor = _resolveComponent("NewMessageUploadEditor")

  return (_openBlock(), _createElementBlock("div", {
    class: "chatView",
    onDragover: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.handleDragOver && $options.handleDragOver(...args)), ["prevent"])),
    onDragleave: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.handleDragLeave && $options.handleDragLeave(...args)), ["prevent"])),
    onDrop: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.handleDropFiles && $options.handleDropFiles(...args)), ["prevent"]))
  }, [
    ($options.showGuestWelcomeWindow)
      ? (_openBlock(), _createBlock(_component_GuestWelcomeWindow, {
          key: 0,
          token: $setup.token
        }, null, 8, ["token"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TransitionWrapper, {
        name: "slide-up",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_NcEmptyContent, {
            name: $options.dropHintText,
            class: "dragover"
          }, {
            icon: _withCtx(() => [
              (!$options.isGuest && !$options.isReadOnly)
                ? (_openBlock(), _createBlock(_component_NcIconSvgWrapper, {
                    key: 0,
                    svg: $setup.IconFileUpload
                  }, null, 8, ["svg"]))
                : ($options.isGuest)
                  ? (_openBlock(), _createBlock(_component_IconAccountOutline, { key: 1 }))
                  : ($options.isReadOnly)
                    ? (_openBlock(), _createBlock(_component_IconAlertOctagonOutline, { key: 2 }))
                    : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["name"]), [
            [_vShow, $data.isDraggingOver]
          ])
        ]),
        _: 1
      }),
      ($props.isSidebar && $setup.threadId)
        ? (_openBlock(), _createBlock(_component_ThreadHeader, {
            key: 0,
            standalone: ""
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_MessagesList, {
        "is-chat-scrolled-to-bottom": $data.isChatScrolledToBottom,
        "onUpdate:isChatScrolledToBottom": _cache[0] || (_cache[0] = $event => (($data.isChatScrolledToBottom) = $event)),
        role: "region",
        "aria-label": $options.t('spreed', 'Conversation messages'),
        token: $setup.token,
        "is-visible": $props.isVisible
      }, null, 8, ["is-chat-scrolled-to-bottom", "aria-label", "token", "is-visible"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TransitionWrapper, { name: "fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_NcButton, {
            variant: "secondary",
            "aria-label": $options.t('spreed', 'Scroll to bottom'),
            title: $options.t('spreed', 'Scroll to bottom'),
            class: "scroll-to-bottom__button",
            onClick: $options.scrollToBottom
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconChevronDoubleDown, { size: 20 })
            ]),
            _: 1
          }, 8, ["aria-label", "title", "onClick"]), [
            [_vShow, !$data.isChatScrolledToBottom && !$options.isLoadingChat]
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_NewMessage, {
      role: "region",
      token: $setup.token,
      "has-typing-indicator": "",
      "aria-label": $options.t('spreed', 'Post message')
    }, null, 8, ["token", "aria-label"]),
    _createVNode(_component_NewMessageUploadEditor)
  ], 32))
}